// Import React entry point first to ensure React is properly loaded
// Use ES module import syntax
import React from './react-entry.js';

// Then import the regular React initialization module
import './react-init';
import './index.css';

// Import global error handler
import { setupGlobalErrorHandlers, logReactStatus } from './error-handler';

// Import dependencies using ES modules
// React is already imported from react-entry.js
import * as ReactDOM from 'react-dom/client';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';

// Log React source to verify it's coming from our entry point
console.log('[main.tsx] React source:', React ? 'From react-entry.js' : 'Not loaded');

// Add detailed logging to help diagnose React context errors
console.log('[main.tsx] Starting application initialization');

// Setup global error handlers to catch React context errors
setupGlobalErrorHandlers();

try {
  // Log React availability and test context creation
  const reactStatus = logReactStatus();
  console.log('[main.tsx] React status check:', reactStatus ? 'OK' : 'FAILED');
  
  // Verify React is properly loaded before continuing
  if (!reactStatus) {
    throw new Error('React is not properly initialized. Cannot continue.');
  }
  
  console.log('[main.tsx] ReactDOM imported successfully');
  console.log('[main.tsx] App component imported successfully');
  console.log('[main.tsx] ErrorBoundary imported successfully');
  
  console.log('[main.tsx] Creating root element');
  // Use React.createElement to avoid JSX transformation issues
  const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
  
  console.log('[main.tsx] Rendering application with ErrorBoundary');
  root.render(
    React.createElement(ErrorBoundary, {
      fallback: React.createElement('div', {}, [
        React.createElement('h1', {}, 'Something went wrong'),
        React.createElement('p', {}, 'Check the console for more details')
      ]),
      children: React.createElement(React.StrictMode, {}, 
        React.createElement(App)
      )
    })
  );
  
  console.log('[main.tsx] Application rendered successfully');
} catch (error) {
  console.error('[main.tsx] CRITICAL ERROR during application initialization:', error);
  console.error('Error details:', {
    message: error.message,
    stack: error.stack,
    reactGlobal: typeof window !== 'undefined' ? Boolean(window.React) : 'window not defined',
    reactInitTimestamp: typeof window !== 'undefined' ? window.__REACT_INIT_TIMESTAMP__ : 'window not defined'
  });
  
  // Display a basic error message for the user
  const rootElement = document.getElementById('root');
  if (rootElement) {
    rootElement.innerHTML = `
      <div style="padding: 20px; font-family: sans-serif;">
        <h1 style="color: #e53e3e;">Application Error</h1>
        <p>The application failed to initialize. Please check the console for more details.</p>
        <div style="background: #f7fafc; padding: 15px; border-radius: 5px; margin-top: 20px;">
          <pre style="margin: 0; white-space: pre-wrap;">${error.message}</pre>
        </div>
      </div>
    `;
  }
}
